var _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494.613,
    height: 107.219,
    viewBox: "0 0 130.866 28.368",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d14254",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d66014",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#logo_svg__a",
    id: "logo_svg__b",
    x1: 34.3,
    y1: 77.3,
    x2: 119.9,
    y2: 77.3,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M184.3 103.4c-1 0-1.8-.3-2.5-1s-1-1.5-1-2.5v-20h-30.7v20c0 1-.3 1.8-1 2.5s-1.5 1-2.5 1-1.8-.3-2.5-1-1-1.5-1-2.5V54.2c0-1 .3-1.9 1-2.5.7-.6 1.5-1 2.5-1s1.9.3 2.5 1c.7.7 1 1.5 1 2.5v19.4h30.7V54.2c0-1 .3-1.9 1-2.5.7-.6 1.5-1 2.5-1s1.9.3 2.5 1c.7.7 1 1.5 1 2.5v45.7c0 1-.3 1.8-1 2.5-.6.7-1.5 1-2.5 1z",
    style: {
      fill: "#000003",
      fillOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M184.3 51.1c.9 0 1.7.3 2.3.9.6.6.9 1.3.9 2.3v45.6c0 .9-.3 1.6-.9 2.2-.6.6-1.3.9-2.3.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2V79.5h-31.5v20.4c0 .9-.3 1.6-.9 2.2-.6.6-1.3.9-2.3.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2V54.2c0-.9.3-1.7.9-2.3.6-.6 1.3-.9 2.2-.9.9 0 1.7.3 2.3.9.6.6.9 1.3.9 2.3V74h31.5V54.2c0-.9.3-1.7.9-2.3.5-.5 1.3-.8 2.2-.8m0-.8c-1.1 0-2 .4-2.8 1.1-.8.7-1.1 1.7-1.1 2.8v19h-29.9v-19c0-1.1-.4-2.1-1.1-2.8-.7-.7-1.7-1.1-2.8-1.1-1.1 0-2 .4-2.8 1.1-.8.7-1.1 1.7-1.1 2.8v45.7c0 1.1.4 2 1.1 2.8.7.7 1.7 1.1 2.8 1.1 1.1 0 2.1-.4 2.8-1.1.7-.7 1.1-1.7 1.1-2.8V80.3h29.9v19.6c0 1.1.4 2 1.1 2.8.7.7 1.7 1.1 2.8 1.1 1.1 0 2.1-.4 2.8-1.1.7-.7 1.1-1.7 1.1-2.8V54.2c0-1.1-.4-2.1-1.1-2.8-.7-.7-1.7-1.1-2.8-1.1z",
    style: {
      fill: "#000003",
      fillOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M216.6 103.7c-3.6 0-6.9-.8-9.7-2.4-2.8-1.6-5.1-3.8-6.7-6.7-1.6-2.8-2.4-6.1-2.4-9.7 0-3.7.8-7 2.4-9.8 1.6-2.8 3.8-5.1 6.7-6.7 2.8-1.6 6.1-2.4 9.7-2.4 3.6 0 6.9.8 9.7 2.4 2.8 1.6 5.1 3.8 6.7 6.7 1.6 2.8 2.4 6.1 2.5 9.8 0 3.7-.8 6.9-2.4 9.8-1.6 2.8-3.9 5.1-6.7 6.7-2.9 1.5-6.2 2.3-9.8 2.3zm0-31.5c-2.3 0-4.4.5-6.2 1.6-1.8 1.1-3.3 2.6-4.3 4.5s-1.6 4.1-1.6 6.6.5 4.7 1.5 6.5c1 1.9 2.5 3.4 4.3 4.4 1.8 1.1 3.9 1.6 6.2 1.6 2.4 0 4.5-.5 6.3-1.6 1.8-1.1 3.2-2.6 4.3-4.4 1-1.9 1.6-4.1 1.6-6.5 0-2.5-.5-4.7-1.6-6.6-1-1.9-2.5-3.4-4.2-4.5-1.9-1-4-1.6-6.3-1.6z",
    style: {
      fill: "#000003",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M216.6 66.4c3.5 0 6.7.8 9.5 2.4 2.8 1.6 4.9 3.7 6.5 6.5 1.6 2.8 2.4 6 2.4 9.6 0 3.6-.8 6.8-2.4 9.6-1.6 2.8-3.8 4.9-6.5 6.5-2.8 1.6-5.9 2.4-9.5 2.4-3.6 0-6.7-.8-9.5-2.4-2.8-1.6-4.9-3.7-6.5-6.5-1.6-2.8-2.4-6-2.4-9.6 0-3.6.8-6.8 2.4-9.6 1.6-2.8 3.7-4.9 6.5-6.5 2.7-1.6 5.9-2.4 9.5-2.4m0 31.5c2.4 0 4.6-.6 6.5-1.7 1.9-1.1 3.3-2.6 4.4-4.6 1.1-2 1.6-4.2 1.6-6.7s-.5-4.8-1.6-6.8-2.5-3.5-4.4-4.6c-1.9-1.1-4-1.7-6.5-1.7-2.4 0-4.5.6-6.4 1.7-1.9 1.1-3.4 2.7-4.4 4.6-1.1 2-1.6 4.2-1.6 6.8 0 2.5.5 4.8 1.6 6.7 1.1 2 2.5 3.5 4.4 4.6 1.8 1.1 4 1.7 6.4 1.7m0-32.3c-3.7 0-7 .8-9.9 2.5-2.9 1.6-5.2 3.9-6.8 6.8-1.6 2.9-2.5 6.2-2.5 10 0 3.7.8 7.1 2.5 9.9 1.6 2.9 3.9 5.2 6.8 6.8 2.9 1.6 6.2 2.5 9.9 2.5s7-.8 9.9-2.5c2.9-1.6 5.2-3.9 6.8-6.8 1.7-2.9 2.5-6.2 2.5-9.9 0-3.8-.9-7.1-2.5-10-1.6-2.9-3.9-5.2-6.8-6.8-2.9-1.7-6.3-2.5-9.9-2.5zm0 31.5c-2.2 0-4.3-.5-6-1.6-1.8-1-3.1-2.5-4.1-4.3-1-1.8-1.5-4-1.5-6.4 0-2.4.5-4.5 1.5-6.4 1-1.8 2.4-3.3 4.1-4.3 1.8-1 3.8-1.6 6-1.6 2.3 0 4.3.5 6.1 1.6 1.7 1 3.1 2.5 4.1 4.3 1 1.9 1.5 4 1.5 6.4 0 2.4-.5 4.5-1.5 6.4-1 1.8-2.4 3.3-4.1 4.3-1.8 1.1-3.9 1.6-6.1 1.6z",
    style: {
      fill: "#000003",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M246.8 103.4c-1 0-1.9-.3-2.5-.9-.6-.6-.9-1.5-.9-2.4v-46c0-1 .3-1.8.9-2.4.6-.6 1.4-.9 2.4-.9s1.9.3 2.5.9c.6.6.9 1.5.9 2.4v46c0 1-.3 1.8-.9 2.4-.6.6-1.4.9-2.4.9z",
    style: {
      fill: "#000003",
      fillOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M246.7 51.1c.9 0 1.7.3 2.2.8.6.6.8 1.3.8 2.2v46c0 .9-.3 1.6-.8 2.2-.6.6-1.3.8-2.2.8-.9 0-1.7-.3-2.2-.8-.6-.6-.8-1.3-.8-2.2v-46c0-.9.3-1.6.8-2.2.6-.6 1.3-.8 2.2-.8m0-.8c-1.1 0-2 .4-2.7 1.1-.7.7-1.1 1.6-1.1 2.7v46c0 1.1.4 2 1.1 2.7.7.7 1.6 1.1 2.8 1.1 1.1 0 2-.4 2.7-1.1.7-.7 1.1-1.6 1.1-2.7v-46c0-1.1-.4-2-1.1-2.7-.7-.8-1.6-1.1-2.8-1.1z",
    style: {
      fill: "#000003",
      fillOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M278.1 103.7c-3.4 0-6.5-.8-9.1-2.5-2.7-1.6-4.8-3.9-6.3-6.7-1.5-2.8-2.3-6.1-2.3-9.6 0-3.6.8-6.9 2.5-9.7 1.6-2.8 3.9-5.1 6.7-6.7 2.8-1.6 6-2.5 9.5-2.5 3.6 0 6.8.8 9.6 2.5 2.8 1.6 5 3.9 6.7 6.8 1.6 2.8 2.5 6.1 2.5 9.6v15.2c0 1-.3 1.8-1 2.5-.7.6-1.5 1-2.5 1s-1.8-.3-2.5-1-1-1.5-1-2.5V98c-1.1 1.3-2.5 2.4-4 3.3-2.5 1.6-5.5 2.4-8.8 2.4zm1-31.5c-2.2 0-4.3.6-6.1 1.6-1.8 1.1-3.3 2.6-4.4 4.5-1 1.9-1.6 4.1-1.6 6.5 0 2.4.5 4.5 1.6 6.4 1 1.9 2.5 3.4 4.4 4.5 1.8 1.1 3.9 1.6 6.1 1.6 2.3 0 4.4-.6 6.2-1.6 1.8-1.1 3.2-2.6 4.3-4.5 1-1.9 1.6-4.1 1.6-6.4 0-2.4-.5-4.6-1.6-6.5-1.1-1.9-2.5-3.4-4.3-4.5-1.8-1-3.9-1.6-6.2-1.6z",
    style: {
      fill: "#000003",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st0",
    d: "M279.1 66.4c3.5 0 6.6.8 9.4 2.4 2.8 1.6 4.9 3.8 6.6 6.6 1.6 2.8 2.5 5.9 2.5 9.5l-4.9-1.9-1.3 6.4v7.5c-1.3 1.6-2.8 3-4.6 4.1-2.6 1.6-5.4 2.3-8.7 2.3-3.3 0-6.3-.8-8.9-2.4-2.6-1.6-4.7-3.8-6.2-6.6s-2.3-5.9-2.3-9.5c0-3.6.8-6.7 2.4-9.5 1.6-2.8 3.8-5 6.6-6.6 2.8-1.5 5.9-2.3 9.4-2.3m0 31.5c2.4 0 4.5-.6 6.4-1.7 1.9-1.1 3.3-2.7 4.4-4.7 1.1-2 1.6-4.2 1.6-6.6 0-2.5-.5-4.7-1.6-6.7s-2.6-3.5-4.4-4.7c-1.9-1.1-4-1.7-6.4-1.7-2.3 0-4.4.6-6.3 1.7-1.9 1.1-3.4 2.7-4.5 4.7s-1.6 4.2-1.6 6.7c0 2.4.5 4.6 1.6 6.6s2.6 3.5 4.5 4.7c1.8 1.1 4 1.7 6.3 1.7m18.4-13v15.2c0 .9-.3 1.6-.9 2.2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2v-3.2c.6-.7 1.1-1.5 1.5-2.3 1.5-2.7 2.3-5.7 2.3-9.1l2.4-.6m-18.4-19.3c-3.6 0-6.9.9-9.7 2.5-2.9 1.7-5.2 4-6.9 6.9-1.7 2.9-2.5 6.2-2.5 9.9 0 3.6.8 6.9 2.4 9.8 1.6 2.9 3.7 5.2 6.5 6.9 2.7 1.7 5.9 2.5 9.3 2.5 3.4 0 6.4-.8 9.1-2.4 1.2-.8 2.4-1.6 3.4-2.7v1.1c0 1.1.4 2 1.1 2.7.7.7 1.6 1.1 2.7 1.1s2-.4 2.8-1.1c.8-.7 1.1-1.7 1.1-2.8V84.9c0-3.6-.9-6.9-2.6-9.8-1.7-2.9-4-5.2-6.8-6.9-3-1.7-6.3-2.6-9.9-2.6zm0 31.5c-2.2 0-4.1-.5-5.9-1.6-1.8-1.1-3.2-2.5-4.2-4.4-1-1.8-1.5-3.9-1.5-6.2 0-2.3.5-4.5 1.5-6.3 1-1.8 2.4-3.3 4.2-4.4 1.8-1.1 3.8-1.6 5.9-1.6 2.2 0 4.3.5 6 1.6 1.7 1.1 3.1 2.5 4.1 4.4 1 1.8 1.5 4 1.5 6.3s-.5 4.4-1.5 6.2c-1 1.8-2.4 3.3-4.1 4.4-1.8 1-3.8 1.6-6 1.6zm13-7.6 1.1-5.4 1.7.7c-.3.1-.6.4-.6.8 0 3.2-.7 6.2-2.2 8.7l-.1.1v-4.9z",
    style: {
      fill: "#000003",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c1220e",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st1",
    d: "M311.3 103c-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2V54.2c0-.9.3-1.7.9-2.3.6-.6 1.3-.9 2.2-.9h12c3.8 0 7.3.6 10.4 1.9 3.1 1.3 5.8 3.1 8.2 5.4 2.3 2.3 4.1 5.1 5.4 8.2 1.3 3.2 1.9 6.6 1.9 10.5 0 3.8-.6 7.3-1.9 10.5-1.3 3.2-3.1 5.9-5.4 8.3-2.3 2.3-5 4.1-8.2 5.4-3.1 1.3-6.6 1.9-10.4 1.9h-12zm3.2-5.5h8.9c3.9 0 7.3-.9 10.2-2.6 3-1.8 5.3-4.2 7-7.3 1.7-3.1 2.6-6.6 2.6-10.6s-.9-7.5-2.6-10.6c-1.7-3.1-4-5.5-7-7.2-3-1.7-6.4-2.6-10.2-2.6h-8.9zM376.2 103.3c-3.7 0-6.9-.8-9.8-2.4-2.8-1.6-5-3.7-6.6-6.5-1.6-2.8-2.4-6-2.4-9.6 0-3.6.8-6.8 2.3-9.6 1.5-2.8 3.6-4.9 6.3-6.5 2.7-1.6 5.7-2.4 9.3-2.4 3.4 0 6.4.8 8.9 2.3 2.5 1.5 4.4 3.6 5.7 6.3 1.3 2.7 2 5.8 2 9.3 0 .8-.3 1.4-.8 1.9s-1.2.8-2 .8h-27.4V82h27.4l-2.7 1.9c0-2.4-.5-4.5-1.4-6.3-.9-1.9-2.2-3.3-3.8-4.4-1.6-1.1-3.6-1.6-5.9-1.6-2.5 0-4.7.6-6.6 1.7-1.8 1.2-3.3 2.7-4.2 4.7-1 2-1.5 4.3-1.5 6.8s.6 4.8 1.7 6.8 2.7 3.5 4.7 4.7c2 1.2 4.3 1.7 6.9 1.7 1.4 0 2.9-.3 4.4-.8 1.5-.5 2.7-1.2 3.6-1.9.6-.5 1.3-.7 2-.8.7 0 1.3.2 1.9.6.7.6 1 1.3 1.1 2 0 .7-.3 1.4-.9 1.9-1.5 1.2-3.4 2.2-5.6 3-2.4.9-4.5 1.3-6.6 1.3zM411.5 103c-1.3 0-2.3-.7-2.9-2l-14.3-30.4c-.4-.7-.4-1.4-.1-2.1.3-.7.8-1.2 1.6-1.5.7-.4 1.4-.4 2.1-.2.7.2 1.2.7 1.6 1.4l13.6 29.3h-3l13.4-29.3c.4-.7.9-1.2 1.7-1.4.8-.2 1.5-.2 2.3.1.7.4 1.2.9 1.5 1.6.3.7.2 1.4-.1 2l-14.2 30.4c-.9 1.4-1.9 2.1-3.2 2.1z",
    style: {
      fill: "#d14254",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.776,
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3314 0 0 .3314 -11.367 -11.434)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "logo_svg__st2",
    cx: 77.1,
    cy: 77.3,
    r: 42.8,
    style: {
      fill: "url(#logo_svg__b)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__st3",
    d: "m51.3 73 25 25.1c3.5 3.5 9.1 3.5 12.6 0l10.8-10.9-3.2.7c-3.1.7-6.4-.3-8.7-2.6L63.4 60.7c-3.4-3.4-8.9-3.4-12.2.1-3.3 3.5-3.2 8.9.1 12.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "logo_svg__st3",
    cx: 97.4,
    cy: 72.3,
    style: {
      fill: "#fff"
    },
    r: 8
  })));
};
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "static/logo.e1052b38.svg";